import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { setTabs } from '../../../actions/spaces/SetTabsWorkbookAction';
import { IEntityAction } from './IEntityAction';

export const SetDisplayTabsAction: IEntityAction<IContentInfo, { setDisplayTabs: boolean }> = {
  name: 'setDisplayTabs',
  translateName: Messages.setDisplayTabs_action,
  isVisible: () => true,
  isClickable: (availableActions: { setDisplayTabs: boolean }) => !!(availableActions && availableActions.setDisplayTabs),
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.every(item => item.contentType === 'workbook')) {
      return setTabs(targetItems);
    } else {
      return null;
    }
  }
};
